import { Component, Input, Output, OnInit, EventEmitter } from '@angular/core';
import { TrackeritemService } from '../../services/trackeritem.service';
import { UiService } from '../../../../core/services/core.ui.service';
import { GfTranslateService } from '../../../../core/services/core.translate.service';

@Component({
  selector: 'trackeritem-multi-delete-modal',
  template: require('./trackeritem.multi.delete.modal.component.html')
})
export class TrackeritemMultiDeleteModalComponent implements OnInit {
  @Input() trackeritemids: any[];
  
  @Output() onClose: EventEmitter<any> = new EventEmitter<any>();
  @Output() onUpdate: EventEmitter<any> = new EventEmitter<any>();

  constructor(
    private uiService: UiService,
    private trackeritemService: TrackeritemService,
    private translateService: GfTranslateService
  ) {}

  ngOnInit() {
  
  }

  close() {
    this.onClose.emit();
  }

  doMassDelete() {
    return this.trackeritemService.deleteItems(this.trackeritemids)
    .then(() => {
        this.uiService.message.showSuccess(
            this.translateService.translate('Successfully deleted tracker items'),
            this.translateService.translate('Mass Update')
        );
  
        this.onUpdate.emit();
    }, () => {
        this.uiService.message.showSuccess(
            this.translateService.translate('Failed to delete tracker items'),
            this.translateService.translate('Mass Update')
        );
    });
  }
}
